import * as React from 'react';
import { AddButton } from 'ui';
import { MdAdd } from 'react-icons/md';
import styles from './file-uploader.scss';

export class FileUploaderAddButton extends React.Component<any, any> {
  private inputElement: HTMLElement;

  private handleUpload(fileList: FileList) {
    this.props.handleUpload(fileList);
  }

  private onUpload = (event: any) => {
    event.preventDefault();
    const fileList: FileList = event.target.files;
    if (fileList && fileList.length) {
      this.handleUpload(fileList);
    }

    // There is no react specific way of clearing or controlling a file input. This will
    // make sure it's possible to re-select the same file, and still have onChange fire.
    // https://stackoverflow.com/questions/42192346/how-to-reset-reacjs-file-input
    event.target.value = null;
  }

  private onClick = (event: any) => {
    if (this.inputElement) {
      this.inputElement.click();
    }
  }

  private onInputElementReady = (element: HTMLElement) => {
    if (element) {
      this.inputElement = element;
    }
  }

  public render() {
    return (
      <div className={`col-sm-12 ${styles.addButtonSection}`}>
        <input
          ref={this.onInputElementReady}
          onChange={this.onUpload}
          type="file"
          multiple />
        <AddButton
          onClick={this.onClick}
          icon={MdAdd}
          required={this.props.required}
        >
          {this.props.addButtonText}
        </AddButton>
      </div>
    );
  }
}
